import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../../apiCalls/rtkBaseQuery';
import { LIST_TRAINING } from '../../../apiCalls/urls/training';
import { GET_LIST } from '../../../apiCalls/urls/common';
export const trainingCalendarApi = createApi({
    baseQuery,
    tagTypes: ['trainingCalendar'],
    reducerPath: 'trainingCalendarApi',
    endpoints: (builder) => ({
        getTrainingCalendarList: builder.query({
            query: (bodyData) => ({
                url: LIST_TRAINING,
                method: 'POST',
                body: bodyData || {}
            }),
            providesTags: ['trainingCalendar'],
            refetchOnMountOrArgChange: true,
        }),
        getList: builder.mutation({
            query: (bodyData) => ({
                url: GET_LIST,
                method: 'POST',
                body: bodyData || {}
            }),
            refetchOnMountOrArgChange: false,
        })
    }),
});

export const {
    useGetTrainingCalendarListQuery,
    useGetListMutation
} = trainingCalendarApi;